export enum TaxRegime {
    mei = 'mei',
    simples = 'simples',
    lucroPresumido = 'lucro_presumido',
    lucroReal = 'lucro_real',
}

export function getLabelTaxRegime(role: TaxRegime): string {
    switch (role) {
        case TaxRegime.mei:
            return 'MEI';
        case TaxRegime.lucroPresumido:
            return 'Lucro Presumido';
        case TaxRegime.lucroReal:
            return 'Lucro Real';
        case TaxRegime.simples:
            return 'Regime Simples';
        default:
            return '';
    }
}

export function listTaxRegime(): TaxRegime[] {
    return Object.values(TaxRegime);
}
